import Layout from '@/views/Layout/index.vue'
const HomeSchoolPage = () => import('@/views/HomeSchoolPage/index.vue')

const Notice = () => import('@/views/HomeSchoolPage/Notice/index.vue')
const Credits = () => import('@/views/HomeSchoolPage/Credits/index.vue')
const Show = () => import('@/views/HomeSchoolPage/Show/index.vue')
const StudentDetail = () => import('@/views/StudentPage/StudentDetail/index.vue');
const ClassFeedback = () => import('@/views/HomeSchoolPage/ClassFeedback/index.vue');
const GrowthPortfolio = () => import('@/views/HomeSchoolPage/GrowthPortfolio/index.vue')
export default {
  path: '/school',
  component: Layout,
  children: [
    {
      path: '',
      component: HomeSchoolPage,
      children: [
        {
          path: '',
          component: Notice,
        },
        {
          path: 'notice',
          component: Notice,
        },
        {
          path: 'studentdetail',
          component: StudentDetail,
        },
        {
          path: 'credits',
          component: Credits,
        },
        {
          path: 'show',
          component: Show,
        },{
          path: 'classFeedback',
          component: ClassFeedback,
        },{
          path:'growthPortfolio',
          component: GrowthPortfolio
        }
      ]
    }
  ]
}
